mutation CreateRefund($input: CreateRefundInput!) {
  createRefund(input: $input) {
    id
    status
    manual
    amount {
      value
      currency
    }
  }
}
